<template>
    <div class="title"  @click="clickItem">
        <p v-if="title">{{ title }}</p>
        <slot v-else></slot>
        <!-- <slot name="extend"></slot> -->
    </div>
</template>

<script>
export default {
    name: "CrudTitle",
    props: {
        title: {
            type: String,
            default: '',
        },
    },
    methods: {
        clickItem() {
            this.$emit('click')
        }
    }
};
</script>
<style scoped lang="scss">
.title {
    margin: 10px 0;
    padding: 0 !important;
    padding-left: 10px !important;
    border-left: 3px solid #409EFF;

    p {
        font-size: 14px;
        margin: 0;
        color: #409EFF;
        font-weight: 500;
    }

    span {
        font-size: 18px;
        font-weight: bold;
        margin: 0;
        color: #409EFF !important;
    }
}
</style>